
import Menu from './Compartido/Menu.jsx';
import BuscadorDestino from './Destino/BuscadorDestino.jsx';
import PropiedadesDestino from './Destino/PropiedadesDestino.jsx';
import DatosDestino from './Destino/DatosDestino.jsx';
import Footer from './Compartido/Footer.jsx';

const Destino = (props) => {
     return (
      <main>
        <Menu
          destinos = {props.destinos}
          sobrenosotros = {props.textosobrenosotros}
          clientes = {props.textoclientes}
          propietarios = {props.textopropietarios}
          servicios = {props.textoservicios}
          experiencias = {props.experiencias}
          idiomas = {props.idiomas}
          lang = {props.lang}
          tiposcasas = {props.tiposcasas}
          config = {props.websgrupo}
          textopropiedades = {props.textopropiedades}
          edificios = {props.edificios}
          marcas = {props.marcas}
          ruta = {props.ruta}
          destinoslarga = {props.destinoslarga}
          meta_titulo = {props.meta_titulo}
          meta_descripcion = {props.meta_descripcion}
          meta_keywords = {props.meta_keywords}
        />
        <BuscadorDestino
          destino = {props.eldestino}
          destinos = {props.destinos}
          tiposcasas = {props.tiposcasasdestino}
          lang = {props.lang}
          config = {props.websgrupo}
        />
        <PropiedadesDestino
          destino = {props.eldestino}
          lang = {props.lang}
          ruta = {props.ruta}
          propiedadesdestino = {props.propiedadesdestino}
          config = {props.websgrupo}
        />
        <DatosDestino
          destino = {props.eldestino}
        />
        <Footer
          datos = {props.websgrupo}
          terminos = {props.textoterminos}
          protocolos = {props.textoprotocolos}
          avisolegal = {props.textoavisolegal}
          config = {props.config}
          elementosweb = {props.elementosweb}
          politicaprivacidad = {props.textopolitica}
          lang = {props.lang}
          ruta = {props.ruta}
          logos_pie = {props.logos_pie}
        />
      </main>
     );
 }

 export default Destino;
